<template>
	<div>
		<div>
			<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
				@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
				<template #default>
					<div ref="logistictrace_custom_form"></div>
					<vxe-grid ref="transferaccountsjindielist" v-if="list_gridOptions" v-bind="list_gridOptions"
						@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				</template>
				<template #footer>
					<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
					<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
				</template>
			</vxe-modal>
		</div>
		<jindieextra ref="transferaccountsjindieextra" :type="type" :obj="obj" :filter="filter"
			@submit="jindieSubmit" />
		<split ref="splitamount" @success="splitSuccess" />
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "500",
			"fApi": [],
			"rule": [{
					"type": "$select",
					"field": "FCONTACTUNITTYPE",
					"title": "往来单位类型",
					"value": "ORG_Organizations",
					"hidden": false,
					"options": [{
						"value": "BD_Supplier",
						"label": "供应商"
					}, {
						"value": "BD_Customer",
						"label": "客户"
					}, {
						"value": "BD_Empinfo",
						"label": "员工"
					}, {
						"value": "FIN_OTHERS",
						"label": "其他往来单位"
					}, {
						"value": "ORG_Organizations",
						"label": "组织机构"
					}, {
						"value": "BD_Department",
						"label": "部门"
					}, {
						"value": "BD_BANK",
						"label": "银行"
					}],
					"props": {

					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "FCONTACTUNIT",
					"title": "往来单位",
					"props": {
						"readonly": true
					},
					"value": "纳智五金",
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "FCONTACTUNIT_FNumber",
					"title": "往来单位ID",
					"props": {
						"readonly": true
					},
					"value": "100",
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "FACCOUNTID",
					"title": "我方银行账号",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "FACCOUNTID_FNumber",
					"title": "我方银行账号ID",
					"props": {
						"readonly": true
					},
					"value": null,
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 12,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import jindieextra from './box/jindieextra.vue'
	import split from './box/split.vue'
	// import BDExpense from '../box/BD_Expense.vue'
	// import BDSETTLETYPE from '../box/BD_SETTLETYPE.vue'
	// import CNRECPAYPURPOSE from '../box/CN_RECPAYPURPOSE.vue'
	// import BDAccount from '../box/BD_Account.vue'
	// import BASPreBaseDataOne from '../box/BAS_PreBaseDataOne.vue'

	export default {
		mixins: [listMixins, modalMixins],
		props: {
			tabledata: {
				default: () => {
					return []
				}
			},
			maindata: {
				default: () => {
					return null
				}
			},
			jindierequire: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '付款单必填项',
				modal_width: 1000,
				modal_height: 600,
				list_autorender: false,
				obj: null,
				type: [],
				field: null,
				formtype: null,
				filter: {},
				loading: false,
				amountfield:[],
				amountfieldName:[]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {


		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				//alert(this.maindata.jindietype)
				if(this.maindata.jindietype == 'AP_PAYBILL'){
					this.amountfield = ['FPAYTOTALAMOUNTFOR','FPAYAMOUNTFOR_E']
					this.amountfieldName = ['应付金额','付款金额']
				}					
				if(this.maindata.jindietype == 'AP_REFUNDBILL'){		
					this.amountfield = ['FREFUNDAMOUNTFOR','FREFUNDAMOUNTFOR_E']
					this.amountfieldName = ['退款金额','退款金额']
				}
				gridOptions.height = 300
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '清空',
						status: 'danger',
						code: 'clear'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width: 50,
					}, {
						field: 'FCOSTID',
						title: '费用项目',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BD_Expense'], column.field,
										'transferaccounts_detail')
								}
							}
						},
					}, {
						field: 'FSETTLETYPEID',
						title: '结算方式',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BD_SETTLETYPE'], column.field,
										'transferaccounts_detail')
								}
							}
						},
					},
					{
						field: 'FPURPOSEID',
						title: '付款用途',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['CN_RECPAYPURPOSE'], column.field,
										'transferaccounts_detail', {
											FRECPAYTYPE: 1
										})
								}
							}
						},
					},
					{
						field: 'F_SXTN_DFKM',
						title: '对方科目',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BD_Account'], column.field,
										'transferaccounts_detail')
								}
							}
						},
					},
					{
						field: 'FEXPENSEDEPTID_E',
						title: '费用承担部门',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BD_Department'], column.field,
										'transferaccounts_detail')
								}
							}
						},
					},
					{
						field: 'F_SXTN_ZZJG',
						title: '组织架构',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BAS_PreBaseDataOne'], column.field,
										'transferaccounts_detail')
								}
							}
						},
					}				
				]				
				this.amountfield.forEach((item,index)=>{
					gridOptions.columns.push({
						field:item,
						title:this.amountfieldName[index]
					})
				})			
				gridOptions.columns.push({
					title: '操作',
					fixed: "right",
					align: 'center',
					width: 65,
					slots: {
						default: ({row,rowIndex}) => {
							if(rowIndex == 0){
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.split(row)}}>拆分</el-button>
								]
							}else{
								return [
									<el-button style="color:#F56C6C" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>
								]
							}
						}
					}
				})	
				gridOptions.formConfig = false
				gridOptions.editRules = {
					FSETTLETYPEID: [{
						required: true,
						message: '缺少必填项【付款用途】',
					}],
					FPURPOSEID: [{
						required: true,
						message: '缺少必填项【付款用途】',
					}]
				}
			},
			list() {
				let jindierequire = this.parseJson()
				if(jindierequire){
					jindierequire.transferaccounts_detail.forEach((item)=>{
						if(this.maindata.jindietype == 'AP_PAYBILL'){
							if(!item.FPAYTOTALAMOUNTFOR){
								item.FPAYTOTALAMOUNTFOR = this.maindata.amount
								item.FPAYAMOUNTFOR_E = this.maindata.amount
							}
						}					
						if(this.maindata.jindietype == 'AP_REFUNDBILL'){		
							if(!item.FREFUNDAMOUNTFOR){
								item.FREFUNDAMOUNTFOR = this.maindata.amount
								item.FREFUNDAMOUNTFOR_E = this.maindata.amount
							}
						}
					})
				}
				return new Promise((resolve) => {
					resolve({
						list: jindierequire ? jindierequire.transferaccounts_detail : this.tabledata
					})
				})
			},
			modal_init() {
				this.list_init()
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
					this.bankacc2jindie()
					//this.data2jindie()
				})
				this.$emit('show')
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			setFormData() {
				let jindierequire = this.parseJson()
				if (jindierequire) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, jindierequire.main[item])
					})
				}
			},
			bankacc2jindie() {
				if (!this.fApi.getValue('FACCOUNTID')) {
					this.loading = true
					this.$api.transferaccounts.jindieextra({
						type: ['CN_BANKACNT', 'CN_CASHACCOUNT']
					}).then((res) => {
						//console.log(res,this.maindata)
						let payobj = res.find((item) => {
							return item.FNumber == this.maindata.rcvAcc
						})
						if (payobj) {
							if (payobj.ModuleType == 'CN_BANKACNT') {
								this.fApi.setValue('FACCOUNTID', payobj.FNumber)
								this.fApi.setValue('FACCOUNTID_FNumber', payobj.FNumber)
								this.tabledata[0].FSETTLETYPEID = '电汇'
								this.tabledata[0].FSETTLETYPEID_FNumber = 'JSFS04_SYS'
							} else {
								this.fApi.setValue('FACCOUNTID', payobj.FNumber)
								this.fApi.setValue('FACCOUNTID_FNumber', payobj.FNumber)
								this.tabledata[0].FSETTLETYPEID = '现金'
								this.tabledata[0].FSETTLETYPEID_FNumber = 'JSFS01_SYS'
							}
						}
						this.loading = false
					}, () => {
						this.loading = false
					})
				}
			},
			data2jindie() {
				if (!this.fApi.getValue('FEXPLANATION')) {
					this.fApi.setValue('FEXPLANATION', this.maindata.mark)
				}
			},
			jindieBoxShow(obj, type, field, formtype, filter = {}) {
				this.obj = obj
				this.type = type
				this.field = field
				this.formtype = formtype
				this.filter = filter
				this.$refs.transferaccountsjindieextra.initList()
				this.$refs.transferaccountsjindieextra.box.alertBox()
			},
			FCONTACTUNITButton() {
				let FCONTACTUNITTYPE = this.fApi.getValue('FCONTACTUNITTYPE')
				let obj = this.fApi.formData()
				if (!FCONTACTUNITTYPE) {
					this.$message.error('请选择往来单位类型')
					return
				}
				let type = [this.fApi.getValue('FCONTACTUNITTYPE')]
				this.jindieBoxShow(obj, type, 'FCONTACTUNIT', 'main')

			},
			FACCOUNTIDButton() {
				let type = ['CN_BANKACNT', 'CN_CASHACCOUNT']
				let obj = this.fApi.formData()
				this.jindieBoxShow(obj, type, 'FACCOUNTID', 'main')
			},
			jindieSubmit(e) {
				//console.log(this.field, e.data)
				if (this.formtype == 'main') {
					console.log(this.field, e.data)
					if (this.field == 'FACCOUNTID') {
						this.fApi.setValue(this.field, e.data.FNumber)
						this.fApi.setValue(this.field + '_FNumber', e.data.FNumber)

						let detail = this.$refs.transferaccountsjindielist.getTableData().fullData
						if (e.data.ModuleType == 'CN_BANKACNT') {
							this.list_batchsettablevalue({
								FSETTLETYPEID: '电汇',
								FSETTLETYPEID_FNumber: 'JSFS04_SYS'
							}, detail)
						} else {
							this.list_batchsettablevalue({
								FSETTLETYPEID: '现金',
								FSETTLETYPEID_FNumber: 'JSFS01_SYS'
							}, detail)
						}
					}
					if (this.field == 'FCONTACTUNIT') {
						this.fApi.setValue(this.field, e.data.FName)
						this.fApi.setValue(this.field + '_FNumber', e.data.FNumber)
					}
				} else {
					let data = this.$refs.transferaccountsjindielist.getCheckboxRecords()
					if (data.length) {
						data.forEach((item) => {
							item[this.field] = e.data.FName
							item[this.field + '_FNumber'] = e.data.FNumber
						})
						//this.$refs.costorderjindielist.clearCheckboxRow()
					} else {
						this.obj[this.field] = e.data.FName
						this.obj[this.field + '_FNumber'] = e.data.FNumber
					}
				}
			},
			split(){
				
				this.$refs.splitamount.modal_show()
			},
			splitSuccess(e){
				let amountfield = this.amountfield				
				let detail = this.$refs.transferaccountsjindielist.getTableData().fullData
				let obj = JSON.parse(JSON.stringify(detail[0]))
				for(let i in amountfield){
					obj[amountfield[i]] = parseFloat(e.data.amount)
				}
				delete obj._X_ROW_KEY

				this.$refs.transferaccountsjindielist.insertAt(obj,-1)
				for(let i in amountfield){
					let amount = parseFloat(detail[0][amountfield[i]]) - parseFloat(obj[amountfield[i]])
					amount = amount.toFixed(4)
					detail[0][amountfield[i]] = amount
				}
				this.$refs.splitamount.modal_cancel()
			},
			delete(row){
				let amountfield = this.amountfield
				this.$refs.transferaccountsjindielist.remove(row)
				let detail = this.$refs.transferaccountsjindielist.getTableData().fullData
				for(let i in amountfield){
					let amount = parseFloat(detail[0][amountfield[i]]) + parseFloat(row[amountfield[i]])
					amount = amount.toFixed(4)
					detail[0][amountfield[i]] = amount
				}
				
			},
			submit() {
				this.fApi.submit((formData) => {
					this.$refs.transferaccountsjindielist.validate(true, (res) => {
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))
							this.submitDataFormater(submitData)
							let detail = this.$refs.transferaccountsjindielist.getTableData().tableData
							let data = {}
							data.main = submitData
							data.transferaccounts_detail = detail
							this.createJson(data)
							//console.log(data,123123)
							this.$emit('success', {
								data: JSON.stringify(data)
							})
							this.modal_cancel()
							console.log(data)
						} else {
							for (let i in res) {
								this.$message.error('缺少必填项：' + res[i][0].column.title)
							}
						}
					})
				})
			},
			removeEmptyFields(obj) {
				return Object.fromEntries(
					Object.entries(obj).filter(([, v]) => v != null && v !== '')
				);
			},
			clear() {
				this.$confirm('是否确认清空', '提示').then(() => {
					this.$emit('clear')
					this.modal_cancel()
				})
			},
			bathedit() {

			},
			createJson(data) {
				//console.log(data,123123)
				let json = {}
				let Model = {}
				let DETAIL = []
				for (let i in data.main) {
					if (!i.includes('FNumber')) {
						if (data.main[i + '_FNumber']) {
							Model[i] = {
								FNumber: data.main[i + '_FNumber']
							}
						} else {
							Model[i] = data.main[i]
						}
					}
				}
				let detail = JSON.parse(JSON.stringify(data.transferaccounts_detail))
				detail = detail.map(this.removeEmptyFields)
				detail.forEach((item) => {
					let obj = {}
					for (let i in item) {
						if (i == 'id') {
							obj.id = item[i]
						}
						if (!i.includes('FNumber') && i.startsWith('F')) {
							if (item[i + '_FNumber']) {
								obj[i] = {
									FNumber: item[i + '_FNumber']
								}
							} else {
								obj[i] = item[i]
							}
						}
					}
					DETAIL.push(obj)
				})
				if (this.maindata.jindietype == 'AP_PAYBILL') {
					Model.FRECTUNITTYPE = Model.FCONTACTUNITTYPE
					Model.FRECTUNIT = Model.FCONTACTUNIT
					Model.FPAYBILLENTRY = DETAIL
				}
				if (this.maindata.jindietype == 'AP_REFUNDBILL') {
					Model.FPAYUNITTYPE = Model.FCONTACTUNITTYPE
					Model.FPAYUNIT = Model.FCONTACTUNIT
					Model.FREFUNDBILLENTRY = DETAIL
				}

				json.Model = Model
				data.json = json
			},
			parseJson() {
				return this.jindierequire ? JSON.parse(this.jindierequire) : null
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			jindieextra,
			split,
			// BDExpense,
			// BDSETTLETYPE,
			// CNRECPAYPURPOSE,
			// BDAccount,
			// BASPreBaseDataOne
		}
	}
</script>